import { render, staticRenderFns } from "./Whatsappcall.vue?vue&type=template&id=70da28de&"
import script from "./Whatsappcall.vue?vue&type=script&lang=js&"
export * from "./Whatsappcall.vue?vue&type=script&lang=js&"
import style0 from "./Whatsappcall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports